import { render, staticRenderFns } from "./inquery.vue?vue&type=template&id=0bd2daac&scoped=true&"
import script from "./inquery.vue?vue&type=script&lang=js&"
export * from "./inquery.vue?vue&type=script&lang=js&"
import style0 from "./inquery.css?vue&type=style&index=0&id=0bd2daac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd2daac",
  null
  
)

export default component.exports